export enum FeedResource {
  Category = 'Category',
  Company = 'Company',
  Guide = 'Guide',
  Product = 'Product',
}

export enum FeedEntryType {
  Feature = 'Feature',
  Collection = 'Collection',
  DynamicCollection = 'DynamicCollection',
}

export interface Feed {
  id: string;
  name: string;
  description_text?: string;
  image_url?: string;
  active: boolean;
  visible_from: Date;
  visible_in: string[];
  visible_worldwide: boolean;
  data: FeedItem[];
}

export type FeedItem = FeedFeature | FeedCollection | FeedDynamicCollection;

export interface FeedFeature {
  type: FeedEntryType;
  id: string;
  name: string;
  description_text?: string;
  public_url?: string;
  image_url?: string;
  resource_type: FeedResource;
  resource_id: string;
}

export interface FeedCollection {
  type: FeedEntryType;
  id: string;
  name: string;
  description_text?: string;
  public_url?: string;
  image_url?: string;
  resource_type: FeedResource;
  resource_ids: string[];
}

export interface FeedDynamicCollection {
  type: FeedEntryType;
  id: string;
  name: string;
  description_text?: string;
  public_url?: string;
  image_url?: string;
  resource_type: FeedResource;
  resource_query: object;
}
